"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _ExternalLink = require("../../../ui-components/ExternalLink");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _InstallationPanel = require("./InstallationPanel");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      isTicketCreationSettingEnabled = _ref.isTicketCreationSettingEnabled,
      isFederatedSearchEnabled = _ref.isFederatedSearchEnabled,
      onSaveTicketCreationSetting = _ref.onSaveTicketCreationSetting,
      onSaveFederatedSearchSetting = _ref.onSaveFederatedSearchSetting,
      onResetTicketCreationSetting = _ref.onResetTicketCreationSetting,
      onResetFederatedSearchSetting = _ref.onResetFederatedSearchSetting,
      onTicketCreationSettingChanged = _ref.onTicketCreationSettingChanged,
      onFederatedSearchSettingChanged = _ref.onFederatedSearchSettingChanged,
      showActionButtons = _ref.showActionButtons,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      _ref$showWarningMessa = _ref.showWarningMessage,
      showWarningMessage = _ref$showWarningMessa === void 0 ? false : _ref$showWarningMessa,
      storedState = _ref.storedState,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isSavingTicketCreationSetting = _ref.isSavingTicketCreationSetting,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting,
      isSyncInProgress = _ref.isSyncInProgress,
      onSyncArticles = _ref.onSyncArticles,
      destination = _ref.destination;
  var TicketCreationIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Create Freshdesk tickets from community posts',
    toggleLabel: 'Enable moderators to create Freshdesk tickets.',
    isInstalled: isInstalled,
    isSettingEnabled: isTicketCreationSettingEnabled,
    storedIsSettingEnabled: storedState.isTicketCreationEnabled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'freshdesk-s',
    description: 'Create a Freshdesk ticket from any user-generated content (questions, conversations, ideas, replies) via Control.',
    onSave: onSaveTicketCreationSetting,
    onCancel: onResetTicketCreationSetting,
    onSettingChanged: onTicketCreationSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-freshdesk-ticket-creation',
    communityArticleLink: 'https://community.insided.com/integrations-124/guide-insided-x-freshdesk-ticket-escalation-integration-3638',
    additionalHelpText: (0, _preact.h)("span", null, "Open a topic from the", ' ', (0, _preact.h)("a", {
      className: "overview-page-link",
      rel: "noreferrer",
      target: "_blank",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/overview")
    }, "content overview"), ' ', "and click the Freshdesk logo next to any user-generated content to create a ticket."),
    additionalInputFields: showWarningMessage && (0, _preact.h)(_Message.Message, {
      variant: "warning",
      text: (0, _preact.h)("div", null, "We've detected that you have some custom ticket fields that are marked as mandatory for agents. Please contact ", (0, _preact.h)("a", {
        href: "mailto:support@freshdesk.com"
      }, "support@freshdesk.com"), " asking them to enable the hidden Freshdesk setting to ignore mandatory fields for agents when creating tickets via the API.")
    }),
    isLoading: isSavingTicketCreationSetting
  });
  var FederatedSearchIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Freshdesk federated search',
    toggleLabel: 'Enable Freshdesk federated search.',
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchEnabled,
    storedIsSettingEnabled: storedState.isFederatedSearchEnabled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'freshdesk-s',
    description: "Empower end users to search Freshdesk articles through ".concat(_constants.PLATFORM_BRAND_NAME, "."),
    onSave: onSaveFederatedSearchSetting,
    onCancel: onResetFederatedSearchSetting,
    onSettingChanged: onFederatedSearchSettingChanged,
    showActionButtons: showActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanel: onClickPanelCallback,
    customClass: 'qa-freshdesk-federated-search',
    communityArticleLink: '',
    additionalHelpText: (0, _preact.h)("span", null, "View Freshdesk articles in the", ' ', (0, _preact.h)("a", {
      className: "overview-page-link",
      href: (0, _absoluteUrlRuntime.resolveUrl)(destination),
      target: "_blank",
      rel: "noreferrer"
    }, "search result"), ' ', "on the community destination."),
    additionalHelpTextBelowToggle: (0, _preact.h)("div", null, (0, _preact.h)("span", null, "The search index is updated automatically every day. Run a synchronization if you'd like to apply content updates to ", _constants.PLATFORM_BRAND_NAME, " immediately."), (0, _preact.h)(_Button.default, {
      size: "medium",
      className: "freshdesk-federated-search-sync-button",
      variant: "secondary",
      title: "Synchronize articles",
      isLoading: isSyncInProgress,
      onClick: onSyncArticles
    })),
    isLoading: isSavingFederatedSearchSetting
  });
  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: [TicketCreationIntegrationPanel, FederatedSearchIntegrationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      apiKey = _ref2.apiKey,
      onClickManage = _ref2.onClickManage,
      onApiKeyChangeCallback = _ref2.onApiKeyChangeCallback,
      onApiKeyClickCallback = _ref2.onApiKeyClickCallback,
      onSubdomainChangeCallback = _ref2.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref2.onSubdomainClickCallback,
      errorMessage = _ref2.errorMessage,
      onClickUninstall = _ref2.onClickUninstall,
      subdomain = _ref2.subdomain,
      errorFields = _ref2.errorFields,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges,
      isSavingCredentials = _ref2.isSavingCredentials;
  var FreshdeskInstallationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onCancel: onCancel,
    apiKey: apiKey,
    onClickManage: onClickManage,
    onApiKeyChangeCallback: onApiKeyChangeCallback,
    onApiKeyClickCallback: onApiKeyClickCallback,
    onSubdomainChangeCallback: onSubdomainChangeCallback,
    onSubdomainClickCallback: onSubdomainClickCallback,
    errorMessage: errorMessage,
    onClickUninstall: onClickUninstall,
    subdomain: subdomain,
    errorFields: errorFields,
    hasUnsavedChanges: hasUnsavedChanges,
    isSavingCredentials: isSavingCredentials
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [FreshdeskInstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How to install the Freshdesk integration step by step",
    url: "https://community.insided.com/integrations-124/guide-insided-x-freshdesk-ticket-escalation-integration-3638",
    isExternalLinkForToggle: false
  }));
};

exports.InstallationTab = InstallationTab;